export const toLocalIsoDate = (date: Date = new Date()): string => {
  const pad = (value: number): string => `${value}`.padStart(2, "0");

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
